// extracted by mini-css-extract-plugin
module.exports = {"list":"e2ff468f85--list--NhS4Q","item":"e2ff468f85--item--uL5K4","arrow":"e2ff468f85--arrow--YIV4a","link":"e2ff468f85--link--Le_2J"};